import React, {ReactNode} from "react"
import {Text} from "scholastic-client-components/src/ui/Text/Text"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"
import {AuthStep} from "../../features/Auth/AuthPageTemplate/AuthPageTemplate"
import mbStyles from "./Heading_mobile.module.scss"
import {Trans, useTranslation} from "react-i18next"

interface HeadingProps {
    authStep: AuthStep
    savePasswordStatus: APIStatus
    request2fa?: boolean
}

export const Heading: React.FC<{children?: ReactNode} & HeadingProps> = ({
    authStep,
    savePasswordStatus,
    request2fa,
}) => {
    const {t} = useTranslation(["auth_portal"])

    const getTitle = () => {
        switch (authStep) {
            case AuthStep.Login:
                if (request2fa) {
                    return <Text>{t("auth_portal:auth_page.tfa_title")}</Text>
                }
                return null
            case AuthStep.CreatePassword:
                if (savePasswordStatus === APIStatus.Success)
                    return <Text noWrap>{t("auth_portal:auth_page.password_created_title")}</Text>
                return <Text noWrap>{t("auth_portal:auth_page.create_password_title")}</Text>
            case AuthStep.ResetPassword:
                return (
                    <Text>
                        <Trans
                            i18nKey={"auth_portal:auth_page.reset_password_title"}
                            components={{lbr: <br />}}
                        />
                    </Text>
                )
            case AuthStep.SuccessResetPassword:
                return (
                    <Text>
                        <Trans
                            i18nKey={"auth_portal:auth_page.email_sent_title"}
                            components={{lbr: <br />}}
                        />
                    </Text>
                )
            default:
                return null
        }
    }
    return <div className={mbStyles.title}>{getTitle()}</div>
}
